/*
  Вкладка «Должники»: с кого взыскиваем и что за помещение — §3.3.5, §7.4.1.

  Заведена 21.09.2026 при разборе карточки на вкладки. Четыре блока собраны
  вместе не по виду, а по вопросу, на который отвечают: прежде чем подавать,
  человек смотрит, НА КОГО подаёт, хватает ли идентификаторов и что за
  помещение пойдёт в финансово-лицевой счёт.

  Порядок внутри вкладки сохранён прежний, и он не случаен:

  1. **Подтверждение состава - первым.** Сначала человек читает, что от него
     требуется, и только потом смотрит список, который подтверждает
     (21.09.2026). Пока пометка стоит, счёт в волну не идёт.
  2. **Люди - вторыми.** Заявление подаётся к человеку, а не к счёту.
  3. **Помещение - третьим.** Финансово-лицевой счёт собирается из обоих блоков
     сразу: кто зарегистрирован и что за квартира. Пустые графы видны до
     подачи, а не в готовом документе (18.09.2026).
  4. **Ссылка в кабинет должника - последней.** Это работа с теми же людьми:
     кому выдали, до какого числа действует, открывал ли он страницу.
*/

import AccountBankruptcy from './AccountBankruptcy.jsx'
import AccountPremises from './AccountPremises.jsx'
import AccountRegistryCheck from './AccountRegistryCheck.jsx'
import DebtorLink from './DebtorLink.jsx'
import AccountParticipants from './entry/AccountParticipants.jsx'
import ParticipantsReview from './ParticipantsReview.jsx'

export default function AccountPeopleTab({ card, canEdit, onDone }) {
  return (
    <>
      <ParticipantsReview
        accountId={card.account_id}
        needsReview={card.participants_need_review}
        canConfirm={canEdit}
        onConfirmed={() => onDone('Состав должников подтверждён.')}
      />

      <AccountParticipants card={card} canEdit={canEdit} onDone={onDone} />

      {/* Банкротство идёт сразу за составом: это сведения о тех же людях, и
          от них зависит, к кому вообще подаётся заявление. Выше помещения -
          потому что помещение отвечает на вопрос «что в документе», а это на
          вопрос «будет ли документ». */}
      <AccountBankruptcy card={card} canEdit={canEdit} onDone={onDone} />

      <AccountRegistryCheck card={card} canEdit={canEdit} />

      <AccountPremises
        accountId={card.account_id}
        premises={card.premises}
        canEdit={canEdit}
        onSaved={() => onDone('Сведения о помещении сохранены.')}
      />

      <DebtorLink accountId={card.account_id} />
    </>
  )
}
